import React from 'react';
import { Building, Factory, Mountain, Train, Snowflake } from 'lucide-react';

const applicationAreas = [
  { icon: <Building className="w-8 h-8 mx-auto mb-2 text-primary-500" />, text: 'Строительные площадки' },
  { icon: <Factory className="w-8 h-8 mx-auto mb-2 text-primary-500" />, text: 'Заводы и комбинаты' },
  { icon: <Mountain className="w-8 h-8 mx-auto mb-2 text-primary-500" />, text: 'Горно-обогатительные предприятия' },
  { icon: <Train className="w-8 h-8 mx-auto mb-2 text-primary-500" />, text: 'Железнодорожная инфраструктура' },
  { icon: <Snowflake className="w-8 h-8 mx-auto mb-2 text-primary-500" />, text: 'Крайнесеверные посёлки и вахты' },
];

const KtpnApplications: React.FC = () => {
  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold">
            Где используются наши КТПН
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            Поставляем КТПН на объекты по всей России и странам СНГ:
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16">
          {applicationAreas.map((area, index) => (
            <div key={index} className="text-center p-4">
              {area.icon}
              <p className="font-semibold text-gray-800">{area.text}</p>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto bg-white p-8 rounded-xl shadow-lg border-l-4 border-accent-500">
          <blockquote className="text-xl italic text-gray-800 relative">
            <span className="absolute -top-4 -left-4 text-6xl text-accent-200 font-serif">"</span>
            «Проминнова поставила 3 КТПН в Норильск. Монтаж за 2 дня. Температуры −55°С — оборудование работает без сбоев уже третий сезон.»
          </blockquote>
          <p className="text-right mt-4 font-semibold text-gray-700">– Отзыв клиента, г. Норильск</p>
        </div>
      </div>
    </section>
  );
};

export default KtpnApplications; 